import { useEffect, useState } from "react";
import {
  deleteService,
  getBusinessServices,
  getSubServices,
  updateServices,
} from "../../../../api/service";
import ServiceCard from "../../orders/allOrders/serviceCard";
import { Pagination, Spin, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import back from "../../../../assets/icons/back.svg";
import SubServiceModal from "../../orders/allOrders/subserviceModal";

const AllServices = () => {
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(8);
  const [render, setRender] = useState(false);
  const [isServiceModalOpen, setServiceIsModalOpen] = useState(false);
  const [selectedParentId, setSelectedParentId] = useState();
  const [selectedSubserviceId, setSelectedSubserviceId] = useState();
  const [selectedServiceId, setSelectedServiceId] = useState();
  const [subService, setSubService] = useState();
  const [showSubServiceId, setShowSubServiceId] = useState();
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const path = location.pathname.split("/");
  const id = path[path.length - 1];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const yesSubserviceClickHandler = async () => {
    const payload = {
      isChild: true,
      parentId: selectedParentId,
      subServiceCategoryId: selectedSubserviceId,
    };

    const res = await updateServices(selectedServiceId, payload);
    if (res) {
      message.success("Converted to Sub-service Successfully!");
      setRender(!render);
    }
    setServiceIsModalOpen(false);
  };

  const hideModal = () => {
    setServiceIsModalOpen(false);
  };

  const getSubService = async () => {
    const res = await getSubServices({
      pageNumber: currentPage,
      pageSize: pageSize,
      parentId: showSubServiceId,
    });
    if (res) {
      setSubService(res);
    }
  };
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  const showSubservice = async (id) => {
    setShowSubServiceId(id);
  };

  const showSubserviceModal = (id) => {
    setSelectedServiceId(id);
    setServiceIsModalOpen(true);
  };

  const fetchData = async () => {
    setLoader(true);
    const res = await getBusinessServices({
      pageNumber: currentPage,
      pageSize: pageSize,
      businessId: id,
    });
    setData(res);
    setLoader(false);
  };

  useEffect(() => {
    if (showSubServiceId) {
      getSubService();
    }
    fetchData();
  }, [pageSize, currentPage, render, showSubServiceId]);

  const itemRender = (page, type, originalElement) => {
    if (type === "page") {
      return (
        <div
          className={`rounded ${
            currentPage === page
              ? "bg-primaryPurple text-white"
              : "bg-white text-black"
          }`}
          style={{ cursor: "pointer" }}
        >
          {page}
        </div>
      );
    }
    return originalElement;
  };

  if (!loader && !data?.totalItems) {
    return (
      <div className="flex justify-center opacity-50 my-2">
        <h1 className="text-xl flex justify-center">No Services Yet</h1>
      </div>
    );
  }

  return (
    <div className="">
      {loader ? (
        <div className="flex h-screen justify-center items-center">
          <Spin
            indicator={<LoadingOutlined />}
            className="flex justify-center"
            size="large"
          />
        </div>
      ) : (
        <div>
          {!showSubServiceId ? (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {data?.items?.map((item, i) => (
                  <div className="relative group " key={i}>
                    <ServiceCard
                      key={i}
                      services={item}
                      sub={true}
                      clicked={(e) => showSubservice(e)}
                      subserviceClick={(e) => showSubserviceModal(e)}
                      fetchData={fetchData}
                    />
                  </div>
                ))}
              </div>
              <div className="flex justify-center items-center my-2">
                <Pagination
                  current={currentPage}
                  total={data?.totalItems}
                  pageSize={pageSize}
                  onShowSizeChange={handleSizeChange}
                  pageSizeOptions={[10, 20, 30, 40]}
                  onChange={(e) => {
                    handlePageChange(e);
                  }}
                  itemRender={itemRender}
                  responsive={true}
                  className="custom-pagination"
                />
              </div>
            </div>
          ) : (
            <div>
              <div className="ml-2 flex items-center mb-4">
                <div
                  className="flex items-center text-black hover:text-black hover:cursor-pointer"
                  onClick={() => setShowSubServiceId(false)}
                >
                  <img alt="back" src={back} />
                  <span className="text-lg ml-1">Sub Services</span>
                </div>
              </div>
              {subService?.totalItems ? (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {subService?.items?.map((item, i) => (
                      <ServiceCard key={i} services={item} />
                    ))}
                  </div>
                  <div className="flex justify-center items-center my-2">
                    <Pagination
                      current={currentPage}
                      total={subService?.totalItems}
                      pageSize={pageSize}
                      onShowSizeChange={handleSizeChange}
                      pageSizeOptions={[10, 20, 30, 40]}
                      onChange={(e) => {
                        handlePageChange(e);
                      }}
                      itemRender={itemRender}
                      responsive={true}
                      className="custom-pagination"
                    />
                  </div>
                </>
              ) : (
                <div className="flex justify-center text-xl opacity-50">
                  No Sub Services
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {isServiceModalOpen && (
        <SubServiceModal
          title="Convert Service to Sub-service"
          onCancel={hideModal}
          subserviceId={(id) => setSelectedSubserviceId(id)}
          parentServiceId={(id) => setSelectedParentId(id)}
          onOk={yesSubserviceClickHandler}
        />
      )}
    </div>
  );
};

export default AllServices;
